import React, {useState} from "react";
import RaiseHand from './RaiseHand';
import QuestionModal from './QuestionModal';

function LecturePlayer({videoUrl, start}) {
    const [showQuestionModal, setShowQuestionModal] = useState(false);
    return (
        <div>
            { showQuestionModal && (
                <QuestionModal setShowQuestionModal={setShowQuestionModal}/>
            )}
            <div className="absolute right-20 top-20">
                <RaiseHand questionCount={1} onClick={() => setShowQuestionModal(true)}/>
            </div>
                <video
                    className="w-full"
                    controls
                    src={videoUrl}
                ></video>
        </div>
    );
}

export default LecturePlayer;